/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ChefEntrepriseSelectorSearch
 */
export interface ChefEntrepriseSelectorSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ChefEntrepriseSelectorSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ChefEntrepriseSelectorSearch
     */
    prenom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ChefEntrepriseSelectorSearch
     */
    numeroNational?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof ChefEntrepriseSelectorSearch
     */
    dateNaissance?: DateSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ChefEntrepriseSelectorSearch
     */
    nationalite?: StringListSearch;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSelectorSearch
     */
    idsiegeSocial?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChefEntrepriseSelectorSearch
     */
    selectedChefEntrepriseIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChefEntrepriseSelectorSearch
     */
    excludedChefEntrepriseIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChefEntrepriseSelectorSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ChefEntrepriseSelectorSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSelectorSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSelectorSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ChefEntrepriseSelectorSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseSelectorSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ChefEntrepriseSelectorSearch interface.
 */
export function instanceOfChefEntrepriseSelectorSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefEntrepriseSelectorSearchFromJSON(json: any): ChefEntrepriseSelectorSearch {
    return ChefEntrepriseSelectorSearchFromJSONTyped(json, false);
}

export function ChefEntrepriseSelectorSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefEntrepriseSelectorSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : TextSearchFromJSON(json['prenom']),
        'numeroNational': !exists(json, 'numeroNational') ? undefined : TextSearchFromJSON(json['numeroNational']),
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : DateSearchFromJSON(json['dateNaissance']),
        'nationalite': !exists(json, 'nationalite') ? undefined : StringListSearchFromJSON(json['nationalite']),
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'selectedChefEntrepriseIds': !exists(json, 'selectedChefEntrepriseIds') ? undefined : json['selectedChefEntrepriseIds'],
        'excludedChefEntrepriseIds': !exists(json, 'excludedChefEntrepriseIds') ? undefined : json['excludedChefEntrepriseIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ChefEntrepriseSelectorSearchToJSON(value?: ChefEntrepriseSelectorSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'prenom': TextSearchToJSON(value.prenom),
        'numeroNational': TextSearchToJSON(value.numeroNational),
        'dateNaissance': DateSearchToJSON(value.dateNaissance),
        'nationalite': StringListSearchToJSON(value.nationalite),
        'idsiegeSocial': value.idsiegeSocial,
        'selectedChefEntrepriseIds': value.selectedChefEntrepriseIds,
        'excludedChefEntrepriseIds': value.excludedChefEntrepriseIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

